<template>
  <div class="page privacy-protocol-qb" v-if="permissions">
    <navigation sticky>权限列表</navigation>
    <section class="content">
      <p class="text tab-2 margin-top-20 bolder">《崇天小贷个人信息保护政策》之“权限列表”</p>
      <p class="text tab-2 margin-top-20 bolder">本列表所附内容您亦可在《崇天隐私政策个人信息保护政策》中查阅，本列表所列内容与《崇天隐私政策个人信息保护政策》中的相关内容一致。</p>
      <p class="text tab-2 margin-top-20 bolder">在您使用我司服务时，会有崇天小额贷款有限公司（简称“崇天小贷”）等SDK技术服务商为您提供人脸识别、身份证影像件核实服务，在提供服务时会向您收集您的身份证信息、人脸信息等，主要包括：</p>
      <table class="table">
        <tr v-for="(item,index) in listPermissions" :key="index" :class="index===0?'grey':''">
          <td v-for="(arr,index) in item" :key="index">
            {{arr.value}}
          </td>
        </tr>
      </table>
      <table class="table">
        <tr v-for="(item,index) in listSDK" :key="index" :class="index===0?'grey':''">
          <td v-for="(arr,index) in item" :key="index">
            {{arr.value}}
          </td>
        </tr>
      </table>
    </section>
  </div>
  <div class="page privacy-protocol-qb" v-else>
    <navigation> 个人信息保护政策</navigation> 
    <section class="content">
      <p class="tab-2">欢迎您使用天美平台(<strong>以下简称"天美平台"或本"平台"</strong>)。作为天美平台的运营主体以及平台服务的提供方，我们(<strong>详见"附件：关键词定义"</strong>)深知个人信息对用户的重要性，并会尽全力保护用户的个人信息安全。我们尊重并保护用户隐私，在您使用平台服务时，我们恪守如下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最小必要原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们将按照本个人信息保护政策<strong>（以下简称“本政策”）</strong>以及业界成熟的安全标准收集、使用和共享您的个人信息。
      </p>
      <p><strong>本政策作为《天美平台用户注册协议》不可分割的组成部分，适用于平台本身向您提供的所有产品和／或服务(以下统称"平台服务")，在使用平台服务前，您知晓并确认您在注册时已经阅读本政策的所有内容，同意我们按照本政策来合法处理您的个人信息。为便于您阅读本政策，我们对所有可能与您的合法利益存在重大关系的条款以及涉及敏感信息内容都通过"加黑或下划线"的书写方式进行了特别提醒，并同时在"附件：关键词定义"中就敏感信息类别予以示例。在向我们提供任何个人敏感信息前，请您结合本政策相关条款清楚考虑该等提供是恰当的并确认是否同意我们可按本政策所述的目的和方式处理您的个人敏感信息。我们会在得到您的同意后收集和使用您的敏感信息，以实现与平台服务相关的功能。您可以拒绝向我们提供这些敏感信息，但是拒绝提供这些信息会影响您使用平台产品和/或服务项下的特定功能。</strong>
      </p>
      <p><strong>如果您不同意本政策的部分或全部内容，请您立即停止使用平台服务并通过平台客服或客服电话4000100008与我们联系。</strong></p>
      <p>本政策将帮助您了解以下内容：</p>
      <p>一、适用范围</p>
      <p>二、我们如何收集您的个人信息</p>
      <p>三、我们如何使用您的个人信息</p>
      <p>四、设备权限调用说明</p>
      <p>五、我们如何共享、转让、公开披露您的个人信息</p>
      <p>六、您如何管理自己的信息</p>
      <p>七、Cookie和类似技术的使用</p>
      <p>八、我们如何保存信息</p>
      <p>九、您的个人信息保护</p>
      <p>十、使用法律与争议解决</p>
      <p>十一、本政策的修订</p>
      <ol>
        <li><strong>一.适用范围</strong></li>
      </ol>
      <p class="underline"><strong>本政策适用于平台提供的所有服务。</strong></p>
      <p><strong>但需要特别说明的是，本政策不适用于由我们的关联公司、关联方或第三方合作机构直接向您提供的产品或服务。针对该等产品或服务，我们建议您在使用之前查看他们的隐私政策，了解他们如何处理您的信息，以便审慎决策。</strong>
      </p>
      <p ><strong><span class="underline">本平台也可能含有到其他网站的链接，我们会依据法律法规的要求采取必要措施对相关网站进行审查（包括审查网站经营者的基本资质、通过技术手段对相关网站的安全情况进行合理且初步识别、督促该等网站经营者根据法律规定保护您的个人信息安全），但我们无法保证该等链接网站的运营方会按照我们的要求采取保护措施。我们建议您查看该等网站的隐私权政策或信息保护声明，了解他们如何处理您的信息，以便审慎决策。</span>本政策涉及的产品和／或服务仅供成年人使用，请您在使用相关产品和/或服务前确保您是18周岁(含)以上人士。如您未达到上述年龄的，请您立即终止使用本平台服务。</strong>
      </p>
      <ol>
        <li><strong>二.我们如何收集您的个人信息</strong></li>
      </ol>
      <p><strong>您同意并授权我们根据您使用的服务收集您如下与服务相关的必要信息。但是我们将不会向您收集法律法规禁止收集的个人信息。您可以选择不提供某一或某些信息，但是这样可能使您无法使用平台的部分服务，但这不会对您使用平台的其他服务产生影响。<span class="underline">目前，本政策仅会出于以下目的收集您的个人信息，如确需改变信息收集的目的和类型时，我们将提前告知您并重新征得您的同意。</span></strong>
      </p>
      <ol>
        <li class="tab-2">1.为了完成会员账户的创建、关联或登录</li>
      </ol>
      <p>当您在平台创建账户时，我们将收集您的<strong>手机号码</strong>用以进行账户注册/登录。当您使用一键登录功能时，平台合作方及运营商将收集您的<strong>SIM卡卡号</strong>，以便能够快速验证您的身份并协助您登录账户。如果您不提供上述信息，您将无法使用一键登录功能，但不影响您对平台内容进行浏览。</p>
      <ol>
        <li class="tab-2">2.为了履行反洗钱法律义务及进行实名制管理</li>
      </ol>
      <p>在您通过平台触发、申请、使用平台关联方或平台合作机构服务时，为实现及时同步更新您在平台、平台关联方和平台合作机构的个人信息（包括身份认证）或完成对您的实名制管理以及履行反洗钱要求，我们需要对您的身份进行识别。为此，我们可能收集您的姓名、<strong>身份证号码及有效期限</strong>、<strong>银行账号、联系方式</strong>。如果您不提供上述信息或您的实名验证未通过，则您无法使用平台对应的服务。
      </p>
      <ol>
        <li class="tab-2"><strong>3.为了提供记账提醒服务</strong></li>
        <li><strong>A.当您使用记账功能时，我们会收集您主动填写的联系方式、信贷信息（包括贷款平台、贷款金额、贷款期限、还款时间）；</strong></li>
        <li><strong>B.当您需要联系客服时，我们可能会收集并使用您反馈标的交易信息（交易金额、交易对象及交易的时间）。若您拨打客服电话进行沟通时，我们还将保存您的手机号码以便后续与您取得联系。如您不提供前述信息，将影响我们向您提供平台对应的服务质量，但是不影响您使用我们提供的其他服务。</strong>
        </li>
        <li class="tab-2">4.为保障您的账户安全</li>
      </ol>
      <p ><strong class="underline">为了提高您使用我们服务的安全性，防止您的个人信息被不法分子获取，</strong>我们需要收集您的<strong>地理位置</strong>、常用设备<strong>信息</strong>(设备型号、操作系统版本、IP地址)来判断您账户的安全性。
      </p>
      <ol>
        <li class="tab-2"><strong>5.根据相关法律法规及国家标准，在以下情形中，我们可能会依法收集并使用您的个人信息无需征得您的同意</strong></li>
      </ol>
      <p>a. 与我们履行法律法规规定的义务相关的；</p>
      <p>b. 与国家安全、国防安全直接相关的；</p>
      <p>c. 与公共安全、公共卫生、重大公共利益直接相关的；</p>
      <p>d. 与刑事侦查、起诉、审判和判决执行等直接有关的；</p>
      <p>e. 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您同意的；</p>
      <p>f. 所涉及的个人信息是您自行向社会公众公开的；</p>
      <p>g. 根据您要求签订和履行合同所必需的；</p>
      <p>h. 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
      <p>i. 维护所提供的产品或服务的安全稳定运行所必需的，如发现、处置产品或服务的故障；</p>
      <p>j. 法律法规规定的其他情形。</p>
      <ol>
        <li><strong>三.我们如何使用您的个人信息</strong></li>
      </ol>
      <p class="tab-2"><strong>1. 为更好地向您提供本服务，也为了我们自身的风险防控，以及保护各方的合法权益，您同意并授权我们在必要时将您的信息用于如下用途：</strong></p>
      <ol>
        <li class="tab-2">(1)实现本政策中“我们如何收集您的个人信息”所述目的</li>
        <li class="tab-2">(2)为保护您的账户安全，对您的身份、银行卡进行识别、验证等；</li>
        <li class="tab-2">(3)用于预防、发现、调查欺诈、危害安全、非法或违反与我们的协议、政策或规则的行为，以保护您、我们的其他用户、或我们的合法权益；</li>
        <li class="tab-2">(4)我们可能会将来自某项服务的信息与来自其他服务的信息结合起来，以便为您提供更优质、个性化的服务、内容和建议；</li>
        <li class="tab-2">(5)遵守任何法律法规和其他对我们、我们的关联公司或我们可信赖的第三方合作伙伴具有约束力的法规中信息披露的要求；</li>
        <li class="tab-2">(6)本协议或其他协议中经您授权许可的其他使用方式。</li>
      </ol>
      <p>希望您能够理解，为了向您提供更为细致与贴心的服务，我们的服务存在一定的发展与更迭。<strong>如在您使用部分服务尚未被前述说明所涵盖时，我们在此明确，基于提供该等更新服务，若我们需要新增收集或使用您的信息，我们会通过页面提示或授权协议约定的方式另行向您说明信息收集的范围与目的，并征得您的同意。</strong>
      </p>
      <p>2. <strong>当我们要将信息用于本政策未载明的其他用途时或当我们要将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。在征求您的同意后，本政策的其他约定同样适用该等信息。</strong></p>
      <ol>
        <li><strong>四.设备权限调用说明</strong></li>
      </ol>
      <p>在提供服务过程中，为了保证您能正常使用产品功能，我们可能会向系统申请开启您的设备权限，申请前我们会告知设备权限开启的目的并征询您的同意，你可以选择“允许”或“禁止”权限申请；申请成功后，您可以随时进入手机“设置-权限管理”中关闭相应权限，权限关闭后相关产品功能可能无法正常使用，但不影响您使用我们的其他服务。在不同设备中，权限显示方式及关闭方式可能有所不同，具体请您参考设备及系统开发方说明或指引。
      </p>
      <ol>
        <li class="tab-2"><strong>1.相册相机权限：</strong></li>
      </ol>
      <p>当您在使用图片记账服务时，您可以通过开通相机权限以便添加图片附件。若您不开启此权限，您将无法使用图片或拍照上传相关的功能，但不影响您使用其他服务。</p>
      <ol>
        <li class="tab-2"><strong>2.使用麦克风权限：</strong></li>
      </ol>
      <p>当您使用天美钱包记账等服务时，您需要准予我们调用您的麦克风权限，以便我们能够通过语音识别的方式提供账单管理服务。您可以在手机系统权限管理中，自主选择开启或关闭授权。若您不开启此权限，您将无法完成账单管理服务，但不会影响您使用其他服务。</p>
      <ol>
        <li><strong>五.我们如何共享、转让、公开披露您的个人信息</strong></li>
      </ol>
      <p class="tab-2"><strong>（一）共享</strong></p>
      <p><strong>我们承诺会根据相关法律法规及监管规定对您的信息承担保密义务。我们不会将您的个人信息与其他第三方进行共享或者对外转让，除非获得您明确的同意或授权。</strong></p>
      <p><strong>在共享信息前，我们会对我们的关联公司或第三方合作伙伴进行数据安全能力审核，与其签署严格的数据安全和保密协定，要求他们按照我们的说明、本政策采取相关的保密和安全措施来处理您的信息。</strong></p>
      <p >（1）为方便我们基于天美平台统一账号向您提供服务，保护我们关联公司/其他用户的人身财产安全免遭侵害或与您取得联系，我们可能会向我们关联公司及我们第三方合作伙伴共享您的必要信息。我们只会共享必要的个人信息（如为便于您使用天美平台统一账号使用我们关联公司产品和/或服务，我们会向关联公司共享您必要的账户信息），如果我们的关联公司或第三方合作伙伴改变个人信息的使用及处理目的，将再次征求您的授权同意；
      </p>
      <p>（2）根据法律规定及合理商业习惯，在平台计划与其他公司合并或被其收购或进行其他资本市场活动（包括但不限于IPO，债券发行）时，以及其他情形下平台需要接受来自其他主体的尽职调查时，则平台在对其用户的信息进行特别处理以使该等信息无法识别特定个人且不能复原后，会把该等信息提供给必要的主体，并且平台会通过和这些主体签署保密协议等方式要求其对该等信息采取合理的保密措施；
      </p>
      <p>（3）当您因使用平台服务发生争议时，为了保护您或可能涉及的第三方的合法权益，我们可能会将您的姓名及<strong>有效证件号码、联系方式</strong>和<strong>与争议相关的信息</strong>提供给监管机关或您与可能涉及的第三方协议（如有）约定的其他争议解决机构，以便及时解决纠纷，但法律法规明确禁止提供的除外；
      </p>
      <p>（4）为遵守适用的法律法规、诉讼目的或者行政机关、司法机构依法提出的要求而披露您的个人信息。如果我们确定您出现违反适用的法律法规或本协议的情况，或为保护我们及我们关联公司或其他用户或公众的权利、财产或安全免遭损害，我们也可能披露关于您的信息，包括相关违规行为以及我们已对您采取的措施；及其他经您事先授权同意的情形。
      </p>
      <p><strong>此外，为了向您更好地提供服务，我们在平台中嵌入了以下第三方软件开发工具包开发服务商的SDK，我们可能会将您的以下个人信息提供给这些SDK开发服务商，以便更好地实现平台各项产品或服务的功能：</strong></p>
      <table class="table">
        <tr v-for="(item,index) in list" :key="index" :class="index===0?'grey':''">
          <td v-for="(arr,index) in item" :key="index">
            {{arr.value}}
          </td>
        </tr>
      </table>
      <p><strong>（二）转让</strong></p>
      <p><strong>我们不会将您的个人信息转让给除平台运营者及其关联公司外的任何公司、组织和个人，但以下情况除外：</strong></p>
      <p>（1）在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</p>
      <p>（2）如果我们或我们的关联公司涉及合并、分立、清算、资产或业务的收购或出售等交易，您的个人信息有可能作为此类交易的一部分而被转移，我们将确保该等信息在转移时的机密性，并尽最大可能确保新的持有您个人信息的公司、组织继续受此政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
      </p>
      <p><strong>（三）公开披露</strong></p>
      <p>我们仅会在以下情况下，公开披露您的个人信息：</p>
      <p>（1）获得您的明确同意；</p>
      <p>（2）基于法律法规、法律程序、诉讼或政府主管部门强制性要求下。</p>
      <p><strong>（四）共享、转让、公开披露个人信息事先征得授权同意的例外</strong></p>
      <p><strong>在以下情形中，共享、转让、公开披露个人信息无需事先征得个人信息主体的授权同意：</strong></p>
      <p>（1）与我们履行法律法规规定的义务相关的；</p>
      <p>（2）与国家安全、国防安全直接相关的；</p>
      <p>（3）与公共安全、公共卫生、重大公共利益直接相关的；</p>
      <p>（4）与刑事侦查、起诉、审判和判决执行等直接相关的；</p>
      <p>（5）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
      <p>（6）您自行向社会公众公开的个人信息；</p>
      <p>（7）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
      <ol>
        <li><strong>六.您如何管理自己的信息</strong></li>
      </ol>
      <p>我们非常尊重您对个人信息的关注，并为您提供了管理个人信息的方法。您有权利查询、更正、管理、删除自己的信息并保护自己的隐私和安全。</p>
      <p>（1）访问权</p>
      <p>除法律法规规定的<strong>例外</strong>情况，无论您何时使用我们的服务，我们都会力求让您顺利访问自己的个人信息。<strong>您可以通过如下方式行使您的访问权利：</strong></p>
      <p>a. 账户信息：如果您希望访问或编辑您的账户中的个人资料信息、更改您的密码、添加安全信息等，您可以在APP端中执行此类操作。</p>
      <p>b. 使用信息：您可以在我们的APP端中查阅您发布的信息、搜索关键词的记录等。</p>
      <p>（2）更正权</p>
      <p>当您需要更新您的个人信息时，或发现我们处理您的个人信息有错误时，您有权作出更正或更新。<strong>您可以自行在相关APP端进行更正，或通过反馈与报错、客服等渠道将您的更正申请提交给我们。</strong>在您进行更新或更正前，我们可能会先要求您验证自己的身份，然后再处理您的请求。
      </p>
      <p>（3）删除权</p>
      <p>发生以下情形，您可以向我们提出删除个人信息的请求：</p>
      <p>a. 如果我们处理个人信息的行为违反法律法规；</p>
      <p>b. 如果收集、使用您的个人信息，却未征得您的同意（但本文件明确不需要征求您同意的除外）；</p>
      <p>c. 如果我们处理个人信息的行为违反了与您的约定；</p>
      <p>d. 如果您不再使用我们的产品或服务，或您注销了账号；</p>
      <p>e. 如果我们终止运营及服务。</p>
      <p>如果我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。</p>
      <p>当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。</p>
      <p>（4）注销权</p>
      <p><strong>我们为您提供申请注销账号的功能。在您的账号无异常的情况下，您可以通过本平台“我的-注销账号”页面申请注销您的账户，您也可以通过拨打客服电话申请注销。</strong>一旦您注销账号，将无法使用与账号相关联的服务，因此请您谨慎操作。为了保护您或他人的合法权益，我们需要在为您注销账号前验证您的身份。除法律法规另有规定外，注销账号之后我们将停止为您提供对应的服务，也不再收集您的个人信息。
      </p>
      <p>（5）管理问题</p>
      <p>a.
      如果您无法通过上述方式访问、更正、删除、注销您的个人信息，或者您就我们收集、使用您信息有任何疑问或者问题，您都可以通过平台客服与我们联系。为保障安全，我们可能需要您提供书面请求，或以其他方式证明您的身份。我们将在收到您的反馈并验证您身份后15日内答复您的相关请求。
      </p>
      <p>b. 我们将尽合理商业努力，满足您对于个人信息的查询、更正、管理的要求。但对于无端重复、需要过多技术手段、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</p>
      <p>c. 对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。</p>
      <p>（6）例外</p>
      <p>按照法律法规要求，以下情况中，<strong>我们将无法响应您的请求：</strong></p>
      <p>a. 与我们履行法律法规规定的义务相关的；</p>
      <p>b. 与国家安全、国防安全直接相关的；</p>
      <p>c. 与公共安全、公共卫生、重大公共利益直接相关的；</p>
      <p>d. 与犯罪侦查、起诉、审判和判决执行等直接有关的；</p>
      <p>e. 有充分证据表明您存在主观恶意或滥用权利的。</p>
      <p>f. 响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>
      <p>g. 维护您或其他个人的生命、财产等重大合法权益但又很难得到您授权同意的；</p>
      <p>h. 涉及商业秘密的；</p>
      <ol>
        <li><strong>七.Cookie和类似技术的使用</strong></li>
      </ol>
      <p>（1）当您使用平台服务时，为使您获得更轻松的访问体验，我们可能会使用各种技术来收集和存储信息，在此过程中可能会向您的设备发送一个或多个 Cookie
      或匿名标识符。这么做是为了解您的使用习惯，使您省去重复输入注册信息等步骤，或帮助判断您的账户安全。</p>
      <p>（2）当您使用平台服务时，我们还可能会利用Cookie和类似技术收取您的信息用于了解您的偏好，进行咨询或数据分析，改善产品服务及用户体验。</p>
      <p>（3）<strong>我们不会将Cookie用于本政策所述目的之外的任何用途，请您理解，我们的某些服务只能通过使用Cookie才可得到实现。如您的浏览器或浏览器附加服务允许，您可以修改对Cookie的接受程度或者拒绝我们的Cookie。多数浏览器工具条中的“帮助”部分会告诉您怎样防止您的浏览器接受新的Cookie，怎样让您的浏览器在您收到一条新Cookie时通知您或者怎样彻底关闭Cookie。此外，您可以通过改变浏览器附加程序的设置，或通过访问提供商的网页，来关闭或删除浏览器附加程序使用的Flash
      Cookie及类似数据。但这一举动在某些情况下可能会影响您安全访问平台网站和使用平台提供的服务。</strong></p>
      <ol>
        <li><strong>八.我们如何保存信息</strong></li>
      </ol>
      <p>（1）保存地域</p>
      <p>您的个人信息将储存于中华人民共和国境内，除您在境外使用平台服务需要数据传输情形外，如需跨境传输，我们会在法律法规的允许范围内，
      按照法律、行政法规和相关监管部门的规定执行，向您告知出境的目的、涉及的个人信息类型、接收方身份、安全风险，且事先征得您的同意，并通过签订协议、安全评估、核查等有效措施，要求境外机构为所获得的个人信息保密并妥善处理，法律法规禁止跨境传输的个人信息除外。
      </p>
      <p>（2）保存期限</p>
      <p>除非法律法规另有规定，我们将按如下期间保存您的信息：</p>
      <p>我们将在实现本政策中所述目的所必需的期间内保留你的个人信息，除非法律法规要求或允许在更长的期间内保留这些信息。</p>
      <p>您的个人信息经匿名化处理后将形成可以使用及流通的数据，我们对此类数据的保存及处理无需另行通知并征得您的同意。</p>
      <p>（3）安全事件</p>
      <p>如不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处理措施、您可自主防范和降低的风险的建议、对您的补救措施等。<strong class="underline">我们会及时将事件相关情况以站内通知、短信通知、电话、邮件等您预留的联系方式告知您，难以逐一告知时我们会采取合理、有效的方式发布公告。</strong>
      </p>
      <p>我们会及时处置系统漏洞、网络攻击、病毒侵袭及网络侵入等安全风险。在发生危害网络安全的事件时，<strong class="underline">我们会按照网络安全事件应急预案，及时采取相应的补救措施，并按照规定向有关主管部门报告。</strong></p>
      <p>如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或损毁，导致您的合法权益受损，我们将严格依照法律的规定承担相应的责任。</p>
      <ol>
        <li><strong>九.您的个人信息保护</strong></li>
      </ol>
      <p>账户信息是非常重要的个人信息，您只能通过您的密码来使用您的账户。请使用复杂密码，协助我们保证您的账户安全。如果您泄漏了密码，您可能丢失了您的身份识别信息，并且可能出现对您不利的后果。因此，请您妥善设置、保管您在平台的账户信息。
      </p>
      <p>我们有相应的安全措施来确保我们掌握的信息不丢失、不被滥用和变造，这些安全措施包括向其它服务器备份数据和对用户信息加密等。尽管我们有这些安全措施，但请注意在信息网络上不存在“完善的安全措施”。<strong class="underline">如您发现自己的个人信息泄密，尤其是您的账户或密码发生泄露，您应该立即通过平台客服与我们取得联系，以便我们采取相应措施。</strong>
      </p>
      <ol>
        <li><strong>十.适用法律与争议解决</strong></li>
      </ol>
      <p>（1）适用法律</p>
      <p>本政策的执行、解释及争议的解决均适用<strong>中华人民共和国法律。</strong></p>
      <p>（2）争议解决</p>
      <p>您和我们就本政策内容或其执行发生任何争议的，双方应友好协商解决；<strong>如双方无法协商解决争议时，双方同意应将争议提交至</strong>我公司<strong>所在地中国重庆渝中区人民法院诉讼解决。</strong>
      </p>
      <ol>
        <li><strong>十一.本政策的修订</strong></li>
      </ol>
      <p><strong>我们可不定期修改本政策，变更后的政策将在平台公告或以其他适当方式进行公告。</strong></p>
      <p><strong>对于重大变更，我们会以特别的形式（包括但不限于弹窗）向您展示变更后的政策。请您注意，只有在您点击弹窗中的同意按钮后，我们才会按照变更后的隐私权政策收集、使用、共享、保存您的个人信息。本政策所指的重大变更主要有：</strong>
      </p>
      <ol>
        <li><strong>1. 我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式；</strong></li>
        <li><strong>2. 我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更；</strong></li>
        <li><strong>3. 您参与个人信息处理方面的权利及其行使方式发生重大变化；</strong></li>
        <li><strong>4. 我们负责处理个人信息安全等事项的联络方式及投诉渠道发生变化时；</strong></li>
        <li><strong>5. 个人信息安全影响评估报告表明存在高风险时。</strong></li>
      </ol>
      <p><strong>我们还会将本政策的旧版本存档，您可以通过本政策约定的沟通渠道与我们联系并进行查阅。</strong></p>
      <ol>
        <li><strong>十二.您如何联系我们</strong></li>
      </ol>
      <p>（1）客服渠道</p>
      <p>如果您对本政策有任何疑问、意见或建议，或您在使用平台服务时，就您的个人信息的收集、使用、共享、访问、删除、更正等相关事宜有任何意见或建议，或您在使用平台服务时遇到任何问题，您都可以通过客服电话或平台上公布的电子邮箱与我们联系。
      </p>
      <p>客服电话：4000100008</p>
      <p>（2）特别提示</p>
      <p>a. 我们提醒您，如您反馈的问题涉及您的个人信息，尤其是您的敏感信息，请您不要直接在电话或邮件中进行透露，我们将会在确保您个人信息安全的情况下与您进一步沟通。</p>
      <p>b. 部分情况下，为保障您个人信息的安全，我们可能需要您提供书面请求，或以其他方式证明您的身份。我们将在收到您的反馈并验证您的身份后15日内答复您的相关请求。</p>
      <p><strong>附件：关键词定义</strong></p>
      <p>为了帮助您更好的了解本政策，将前述条款中的部分名词进行解释如下：</p>
      <p>•<strong>我们</strong>是指重庆市崇天小额贷款有限公司，注册地址：重庆市南岸区南滨路22号1栋长江国际大厦33层3319室；联系方式：4000100008。</p>
      <p>•<strong>平台</strong>是指我们为用户提供服务的相应网站、移动客户端以及以其他形式提供的操作环境。</p>
      <p>•<strong>Cookie</strong>是指支持服务器端（或者脚本）在客户端上存储和检索信息的一种机制，通过增加简单、持续的客户端状态来扩展基于Web的客户端/服务器应用。服务器在向客户端返回HTTP对象的同时发送一条状态信息，并由客户端保存。状态信息中说明了该状态下有效的URL范围。此后，客户端发起的该范围内的HTTP请求都将把该状态信息的当前值从客户端返回给服务器，这个状态信息被称为cookie。
      </p>
      <p>•<strong>匿名化</strong>是指通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。</p>
      <p>•<strong>平台关联公司或关联公司</strong>是指与我们存在关联关系的公司的单称或合称。“关联关系”是指对于任何主体（包括个人、公司、合伙企业、组织或其他任何实体）而言，即其直接或间接控制的主体，或直接或间接控制其的主体，或直接或间接与其受同一主体控制的主体。前述“控制”指，通过持有表决权、合约或其他方式，直接或间接地拥有对相关主体的管理和决策作出指示或责成他人作出指示的权力或事实上构成实际控制的其他关系。
      </p>
      <p>•<strong>平台合作机构或合作机构</strong>是指与我们签署相关合作或服务协议，同意根据协议约定并基于平台服务向用户提供记账提醒相关服务的机构。</p>
      <p >
        •<strong>平台统一账号是指</strong>您使用手机号码在任一天美平台注册完成后取得的账号，您使用该账号可以登录天美平台运营商旗下的任一平台。您在使用统一登录账号登录相关天美平台时需要再次确认相关天美平台的用户注册协议、隐私权政策等各类规则。
      </p>
      <p>•个人信息及个人敏感信息示例（<strong>以下表格内容并非我们所收集的全部个人信息，仅作示例说明</strong>）</p>
      <table class='mt20'>
        <tr>
          <td >
            个人信息举例
          </td>
          <td/>
        </tr>
        <tr>
          <td>
            个人基本信息
          </td>
          <td>
            电话号码
          </td>
        </tr>
        <tr>
          <td>
            个人财产信息
          </td>
          <td>
            银行账号、信用卡账单
          </td>
        </tr>
      </table>
      <table class="mt20">
        <tr>
          <td >
            个人敏感信息举例
          </td>
          <td/>
        </tr>
        <tr>
          <td>
            网络身份标识信息
          </td>
          <td>
            IP地址
          </td>
        </tr>
        <tr>
          <td>
            个人财产信息
          </td>
          <td>
            银行账号、银行流水、信用卡账单
          </td>
        </tr>
        <tr>
          <td>
            交易信息
          </td>
          <td>
            交易对象、交易时间、交易金额
          </td>
        </tr>
      </table>
    </section>
  </div>

</template>

<script>
export default {
  name: 'protocol-privacyqb',

  description: '注册天美钱包协议',
  data () {
    return {
      list: [
        [{ key: 0, value: 'SDK名称' }, { key: 1, value: '适用系统' }, { key: 2, value: '实现功能及场景' }, { key: 3, value: 'SDK提供方名称' }, { key: 4, value: '个人信息类型' }, { key: 5, value: '调用的设备权限' }],
        [{ key: 0, value: '极光一键登录SDK' }, { key: 1, value: 'iOS；Android；H5' }, { key: 2, value: '平台账号一键登录' }, { key: 3, value: '深圳市和讯华谷信息技术有限公司' }, { key: 4, value: '个人设备信息（SIM卡号）' }, { key: 5, value: '无' }],
        [{ key: 0, value: '科大讯飞SDK' }, { key: 1, value: 'iOS' }, { key: 2, value: '语音语义识别' }, { key: 3, value: '科大讯飞股份有限公司' }, { key: 4, value: '声音信息' }, { key: 5, value: '麦克风权限' }]
      ],
      permissions: !!['pre'].includes(this.$route.query.permissions),
      listSDK: [
        [{ key: 0, value: 'SDK名称' }, { key: 1, value: '用途' }, { key: 2, value: '备注' }],
        [{ key: 0, value: '极光一键登录SDK' }, { key: 1, value: '用户使用本机号码一键登录' }, { key: 2, value: '该信息为使用该功能SDK内部采集，天美贷平台不收集、不存储您在第三方SDK服务页面填写和提交的任何个人信息' }],
        [{ key: 0, value: '科大讯飞SDK' }, { key: 1, value: '语音语义识别；完成用户语音文本转化输入' }, { key: 2, value: '该信息为使用该功能SDK内部采集，天美贷平台不收集、不存储您在第三方SDK服务页面填写和提交的任何个人信息' }]
      ],
      listPermissions: [
        [{ key: 0, value: 'APP权限' }, { key: 1, value: '收集目的' }],
        [{ key: 0, value: '1. 相机权限' }, { key: 1, value: ' 用于用户添加个人信息图片以及人脸识别' }],
        [{ key: 0, value: '2. 位置权限 - 添加信用卡账单' }, { key: 1, value: '为了验证您本人身份；防止欺诈风险，避免您的账号被非法盗用进而导致您账号中的信息泄露，同时保障您的账号财产安全' }],
        [{ key: 0, value: '3. 麦克风 - 语音识别 ' }, { key: 1, value: '为了验证您本人身份；防止欺诈风险，避免您的账号被非法盗用进而导致您账号中的信息泄露，同时保障您的账号财产安全' }],
        [{ key: 0, value: '4. App Tracking Transparency应用相关数据' }, { key: 1, value: '苹果应用市场要求添加为更好地进行用户账户信息服务' }]
      ]
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/mixin.less";

    .privacy-protocol-qb {
        background-color: #FAFAFA;
        padding-bottom: 45px;
        .tab-2,p{
            text-indent: 2em;
        }
        .underline {
        text-decoration: underline;
    }
        .grey{
                font-size: 26px;
                line-height: 33px;
                font-family: PingFangSC-Regular,PingFang SC;
                font-weight: 400;
                color: @fc2;
                background:rgb(208,206,206)
        }
    table {
                border-spacing: 0;
                border-collapse: collapse;
                margin: unset;
                width:100%;
                td {
                    border-color: @fc3;
                    border-width: 1;
                    border-style: solid;
                    padding: 10px 0;
                    padding-left: 10px;
                    line-height: 1.4em;
                }
            }
        .mt20{
            margin-top:20px;
        }
        .content {
            padding: 0 35px 90px;
            border-radius: 20px;
            background-color: #FFFFFF;
            overflow: hidden;
            text-indent: 4px;

            p {
                margin-top: 12px;
                font-size: 26px;
                line-height: 33px;
                font-family: PingFangSC-Regular,PingFang SC;
                font-weight: 400;
                color: @fc2;
            }
        }
    }
</style>